import dayjs from 'dayjs';
import { ChampCompteRendu } from '../compte-rendu/champ-compte-rendu.model';
import { Coordinates } from '../coordinates.model';
import { UUID } from '../uuid.model';
import { UserEvent } from './user-event.model';

export class ArriveeSurSiteEvent extends UserEvent {
  public static NAME = 'ARRIVEE_SUR_SITE_EVENT';

  constructor(
    public idAffectation: string,
    public id: UUID,
    public time: dayjs.Dayjs,
    public champsPersonnalises: ChampCompteRendu[] = [],
    coordinates?: Coordinates
  ) {
    super(ArriveeSurSiteEvent.NAME, time, coordinates);
  }

  public static hydrate(obj: ArriveeSurSiteEvent): ArriveeSurSiteEvent {
    return new ArriveeSurSiteEvent(obj.idAffectation, obj.id, dayjs(obj.time), obj.champsPersonnalises, obj.coordinates);
  }
}
